import { filterBySearchTerm } from './search';

/**
 * Filtra usuários por cargoId
 */
export const filterUsersByCargo = (users, cargoId) => {
  if (!cargoId || cargoId === 'all') {
    return users;
  }
  
  return users.filter(user => {
    const userCargoId = user.cargoId || user.cargo_id;
    return userCargoId == cargoId;
  });
};

/**
 * Ordena usuários por diferentes critérios
 */
export const sortUsers = (users, sortBy = 'nome', order = 'asc') => {
  const sortedUsers = [...users].sort((a, b) => {
    let valueA, valueB;
    
    switch (sortBy) {
      case 'cargo':
        valueA = a.cargo || a.cargoNome || '';
        valueB = b.cargo || b.cargoNome || '';
        break;
      case 'nome':
      default:
        valueA = a.nome || '';
        valueB = b.nome || '';
        break;
    }
    
    valueA = valueA.toString().toLowerCase();
    valueB = valueB.toString().toLowerCase();
    
    if (order === 'desc') {
      return valueB.localeCompare(valueA);
    }
    
    return valueA.localeCompare(valueB);
  });
  
  return sortedUsers;
};

/**
 * Aplica filtros e ordenação aos usuários
 */
export const applyUserFilters = (users, filters = {}) => {
  let filteredUsers = users;
  
  if (filters.cargoId) {
    filteredUsers = filterUsersByCargo(filteredUsers, filters.cargoId);
  }
  
  if (filters.searchTerm) {
    filteredUsers = filterBySearchTerm(filteredUsers, filters.searchTerm, [
      (user) => user.nome,
      (user) => user.email,
      (user) => user.cpf,
      (user) => user.cargo || user.cargoNome,
    ]);
  }

  if (filters.sortBy || filters.order) {
    filteredUsers = sortUsers(
      filteredUsers, 
      filters.sortBy || 'nome', 
      filters.order || 'asc'
    );
  }
  
  return filteredUsers;
};

/**
 * Opções de filtro por cargo
 */
export const CARGO_FILTER_OPTIONS = [
  { value: 'all', label: 'Todos os cargos' },
  { value: 1, label: 'Gerenciador Geral dos Estágios' },
  { value: 2, label: 'Coordenador da Instituição de Ensino' },
  { value: 3, label: 'Coordenador de Estágio dos Cursos' },
  { value: 4, label: 'Gestor/ Colaborador NEPS/GEPS' }
];

/**
 * Opções de ordenação
 */
export const SORT_OPTIONS = [
  { value: 'nome', label: 'Nome (A-Z)', order: 'asc' },
  { value: 'nome', label: 'Nome (Z-A)', order: 'desc' },
  { value: 'cargo', label: 'Cargo (A-Z)', order: 'asc' },
  { value: 'cargo', label: 'Cargo (Z-A)', order: 'desc' }
];
